export function micYearLoading(resp = {}, store = {}) {
  return {
    type: 'MIC_YEAR_LOADING',
    micYear: resp,
    store
  };
}

export function micYearLoaded(resp = {}, store = {}, year) {
  return {
    type: 'MIC_YEAR_LOADED',
    micYear: resp,
    store,
    year
  };
}

export function micYearLoadError(error, store = {}) {
  return {
    type: 'MIC_YEAR_ERROR',
    micYear: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}
